import React from 'react';
const tomos = [{
  icon: '📘',
  title: 'TOMO 1 — Manual Maestro del Carpintero de Acero',
  desc: 'La base técnica completa. Tipos de caño, herramientas, corte con amoladora, soldadura para muebles, combinación hierro-madera y acabados profesionales.'
}, {
  icon: '📗',
  title: 'TOMO 2 — El Catálogo de los 10 Más Vendidos',
  desc: 'Los 10 muebles con mayor demanda en Marketplace Argentina. Planos, medidas, lista de materiales y tabla de costos y ganancia de cada uno.'
}, {
  icon: '📙',
  title: 'TOMO 3 — Guía de Costeo y Presupuesto Anti-Inflación',
  desc: 'El sistema de precios que te protege de la inflación. Fórmula Maestra de Precios, guiones para responder "está caro" y planilla de costeo lista para usar.'
}, {
  icon: '📕',
  title: 'TOMO 4 — Master de Ventas en Marketplace y WhatsApp',
  desc: 'El sistema completo de ventas. Cómo publicar para el algoritmo, fotos que venden solas, guiones de WhatsApp que cierran ventas sin regatear.'
}, {
  icon: '📔',
  title: 'TOMO 5 — Diseños en Melamina y Muebles Combinados',
  desc: 'Expandí tu catálogo y duplicá tu ticket promedio. Colores más vendidos, diseños combinados, uniones profesionales y servicio de instalación.'
}];
export function TomosDetail() {
  return <section className="pt-10 pb-20 px-4 bg-white" data-id="element-332">
      <div className="max-w-4xl mx-auto" data-id="element-333">
        <div className="text-center mb-16" data-id="element-334">
          <h2 className="text-4xl font-black text-brand-dark mb-4" data-id="element-335">
            Lo que recibís hoy
          </h2>
          <div className="inline-block bg-brand-steel text-white font-bold px-6 py-2 rounded-lg text-xl" data-id="element-336">
            📦 MEGA PACK — 5 Tomos Maestros
          </div>
          <p className="text-xl text-gray-600 mt-4 font-medium" data-id="element-337">
            El sistema completo para pasar de cero a tu primera venta
          </p>
        </div>

        <div className="space-y-6" data-id="element-338">
          {tomos.map((t, i) => <div key={i} className="bg-white border-2 border-gray-100 p-6 md:p-8 rounded-2xl shadow-lg hover:shadow-xl transition-shadow flex flex-col md:flex-row gap-6 items-start" data-id="element-339">
              <div className="text-6xl flex-shrink-0" data-id="element-340">{t.icon}</div>
              <div data-id="element-341">
                <h3 className="text-2xl font-bold text-brand-dark mb-3" data-id="element-342">
                  {t.title}
                </h3>
                <p className="text-lg text-gray-600 leading-relaxed" data-id="element-343">
                  {t.desc}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}